// extracted by mini-css-extract-plugin
export default {"jobsListContainer":"_2qt7Vvdn","jobsListTitle":"_1ZMcIAWv","jobsListItem":"_1YRBQ30d"};